import { styled } from 'react-alicerce-components';

export const WrapperContentContainer = styled.div`
  .custom-card > div {
    margin: var(--card-distance);
  }
`;
